var UiError = /** @class */ (function () {
    function UiError() {
        this.hasErrorFlag = false;
        this.errorMessage = '';
        this.severity = 'normal';
    }
    return UiError;
}());
export { UiError };
//# sourceMappingURL=uiError.js.map